export default __webpack_public_path__ + "static/media/uno.4d7562c3.jpg";